<template>
    <div class="orderorder">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-button type="" size="mini" :disabled="isAdd || !isedit || nullBtn" @click="ExportData">{{ $t('common.export') }}</el-button>
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                    >{{ $t('common.add') }}</el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                    form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                }}</el-button>
            </div>
        </div>

        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isedit"
                                    :clearables="true"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.counter') + '：'" label-width="180">
                            <el-select
                                v-model="form.counter_no"
                                clearable
                                default-first-option
                                filterable
                                placeholder="请选择"
                                :disabled="isedit"
                                @change="counterChange"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.counter"
                                    :key="index"
                                    :label="item.counter_no + ' - ' + item.counter_name"
                                    :value="item.counter_no.toString()"
                                    :disabled="item['islock'] == 0 ? true : false || item.status == 0"
                                >
                                    <span style="float: left; color: #8492a6; font-size: 13px; margin-right: 10px"
                                        ><el-tag style="margin-right: 10px" type="danger" v-if="item['islock'] == 1 ? true : false"
                                            >锁定</el-tag
                                        >{{ item['counter_no'] || item }}</span
                                    >
                                    <span style="float: right">{{ item['counter_name'] }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isedit"
                                :clearables="true"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-button :disabled="isedit" @click="calculateDifferences" style="margin-top: 30px" type="primary"
                            >计算差异</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="table_warpper">
            <div class="table1" style="width: 49%">
                <div class="title">
                    <p>明细</p>
                    <!-- <el-input
                        class="ipt"
                        @keydown.enter="insertTableBcode($event)"
                        :disabled="isedit"
                        placeholder="请输入条码"
                        v-model="dtlBarcode"
                        clearable
                    >
                    </el-input> -->
                    <input
                        :disabled="isedit"
                        placeholder="请输入条码号"
                        @keydown.enter="insertTableBcode($event)"
                        v-model.lazy="dtlBarcode"
                        clearable
                        style="width: 250px; margin: 5px 0 5px 20px; height: 32px; font-size: 14px"
                        class="el-textarea__inner"
                    />
                    <el-button
                        style="margin-left: 0px; border-radius: 0px !important"
                        type="primary"
                        :disabled="isedit"
                        @click="dialogTrueFalse"
                        >合并盘点单</el-button
                    >
                    <el-button style="margin-left: 10px" type="primary" :disabled="isedit" @click="showImpotOpen">RFID盘点</el-button>

                    <el-button style="margin-left: 10px" type="primary" :disabled="isedit" @click="showImpotDialogdr = true"
                        >导入</el-button
                    >
                </div>
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"
                    ref="xTable1"
                    show-overflow
                    highlight-hover-row
                    :loading="loading"
                    :auto-resize="true"
                    :height="maxHeightLeft"
                    show-footer-overflow
                    :keyboard-config="{ isArrow: true, isDel: true, isEdit: true }"
                    :row-class-name="rowChange"
                    :data="form.dtl"
                    @cell-mouseenter="dtlenter"
                    :key="refushTable"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column field="seq" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                                <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                            </span>
                            <span v-if="scoped.$rowIndex != dtlIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="item.column_status == 1 && item.column_type != 'select'"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    :type="item.column_type"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.islock == 0 ? true : false || option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template> </vxe-table-column
                    ></template>
                    <template #empty>
                        <span style="color: red">
                            <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
            <div class="table_right">
                <div class="table1">
                    <div class="title">
                        <p>盘盈</p>
                    </div>
                    <vxe-table
                        border
                        stripe
                        resizable
                        keep-source
                        align="center"
                        ref="xTable2"
                        :height="maxHeight"
                        :auto-resize="true"
                        show-overflow
                        highlight-hover-row
                        :loading="loading"
                        show-footer-overflow
                        :keyboard-config="{ isArrow: true, isDel: true, isEdit: true }"
                        :row-class-name="rowChange"
                        :data="form.profit"
                        :scroll-y="{ enabled: true, gt: 50 }"
                    >
                        <vxe-table-column type="seq" width="70" align="center">
                            <template slot="header">
                                <i class="el-icon-setting" @click.stop="isedit ? changeTable(2) : null"></i>
                            </template>
                        </vxe-table-column>

                        <template v-for="(item, index) in zkKeyList">
                            <vxe-table-column
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{
                                    name: 'input',
                                    attrs: { type: item.column_type },
                                    autoselect: true,
                                    autofocus: '.vxe-input--inner'
                                }"
                                v-if="item.column_status == 1 && item.column_type != 'select'"
                            >
                                <template v-slot:edit="{ row }">
                                    <vxe-input
                                        :type="item.column_type"
                                        @keydown.native="jumptable($event, row, item.field)"
                                        v-model="row[item.field]"
                                        @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    ></vxe-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type == 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{ autofocus: '.el-input__inner' }"
                            >
                                <template #default="{ row }">
                                    <span>{{
                                        $selectLable.selectLable(
                                            row[item.field],
                                            allArr[item.field.replace('_no', '')],
                                            item.field,
                                            item.field.replace('_no', '_name')
                                        )
                                    }}</span>
                                </template>
                                <template v-slot:edit="{ row }">
                                    <el-select
                                        size="mini"
                                        v-model="row[item.field]"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        @change="changeData(row, item.field.replace('_no', ''))"
                                        @keydown.native="jumptable($event, row, item.field)"
                                    >
                                        <el-option
                                            v-for="option in allArr[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </vxe-table-column>
                        </template>
                        <template #empty>
                            <span style="color: red">
                                <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
                <div class="table1">
                    <div class="title">
                        <p>盘亏</p>
                    </div>
                    <vxe-table
                        border
                        stripe
                        resizable
                        keep-source
                        align="center"
                        ref="xTable3"
                        :height="maxHeight"
                        :auto-resize="true"
                        show-overflow
                        highlight-hover-row
                        :loading="loading"
                        show-footer-overflow
                        :keyboard-config="{ isArrow: true, isDel: true, isEdit: true }"
                        :row-class-name="rowChange"
                        :data="form.loss"
                        :scroll-y="{ enabled: true, gt: 50 }"
                    >
                        <vxe-table-column type="seq" width="70" align="center">
                            <template slot="header">
                                <i class="el-icon-setting" @click.stop="isedit ? changeTable(3) : null"></i>
                            </template>
                        </vxe-table-column>

                        <template v-for="(item, index) in fkKeyList">
                            <vxe-table-column
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{
                                    name: 'input',
                                    attrs: { type: item.column_type },
                                    autoselect: true,
                                    autofocus: '.vxe-input--inner'
                                }"
                                v-if="item.column_status == 1 && item.column_type != 'select'"
                            >
                                <template v-slot:edit="{ row }">
                                    <vxe-input
                                        :type="item.column_type"
                                        @keydown.native="jumptable($event, row, item.field)"
                                        v-model="row[item.field]"
                                        @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    ></vxe-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type == 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{ autofocus: '.el-input__inner' }"
                            >
                                <template #default="{ row }">
                                    <span>{{
                                        $selectLable.selectLable(
                                            row[item.field],
                                            allArr[item.field.replace('_no', '')],
                                            item.field,
                                            item.field.replace('_no', '_name')
                                        )
                                    }}</span>
                                </template>
                                <template v-slot:edit="{ row }">
                                    <el-select
                                        size="mini"
                                        v-model="row[item.field]"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        @change="changeData(row, item.field.replace('_no', ''))"
                                        @keydown.native="jumptable($event, row, item.field)"
                                    >
                                        <el-option
                                            v-for="option in allArr[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </vxe-table-column>
                        </template>
                        <template #empty>
                            <span style="color: red">
                                <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
            </div>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="盘点重量：">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item label="盘盈重量：">
                        <p>{{ form.profitwgt }}</p>
                    </el-form-item>
                    <el-form-item label="盘亏重量：">
                        <p>{{ form.losswgt }}</p>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label="盘点数量：">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item label="盘盈数量：">
                        <p>{{ form.profitqty }}</p>
                    </el-form-item>
                    <el-form-item label="盘亏数量：">
                        <p>{{ form.lossqty }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <el-select v-model="insertKeywords" placeholder="请选择" multiple filterable clearable>
                <el-option v-for="item in insertKeywordsArr" :key="item.id" :label="item.bill_no" :value="item.id">
                    <span style="float: left">{{ item.bill_no }}</span>
                    <span style="float: right">{{ item.bill_date }}</span></el-option
                >
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="specschange(insertKeywords)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="showImpotDialog" width="25%" :before-close="handleClose">
            <el-form label-width="80px">
                <el-form-item label="设备">
                    <el-select
                        style="margin-bottom: 50px; width: 80%"
                        v-model="insertAllData"
                        placeholder="请选择"
                        multiple
                        filterable
                        clearable
                    >
                        <el-option v-for="item in allArrData" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="closingTrue">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialogdr" width="45%" :before-close="handleCloses">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :before-upload="imptBeforeUpload"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'importdtl_barcodestockcheck'"
                        multiple
                        :data="uploadData"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialogdr = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialogdr = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiGetInventoryCheckData,
    apiGetInventorygetRfidPull,
    apiGetInventorygetRfidData,
    apiGetInventoryGetBillnos,
    apiGetInventoryMergeBill,
    apiGetInventoryCheckPull,
    apiModifyInventoryCheckData,
    apiAddInventoryCheckData,
    apiDelInventoryCheckData,
    apiCurrentPermisson,
    apiCheckInventoryCheck,
    apiSystem,
    apiGetInventoryCheckBroadData,
    apiCountInventoryCheckDiff,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'barcodestockcheck',
    data() {
        return {
            insertKeywordsArr: [],
            insertKeywords: [],
            dialogVisible: false,
            insertAllData: [],
            showImpotDialog: false,
            uploadData: {},
            showImpotDialogdr: false,
            headers: {},
            allArrData: [],
            allArr: '',
            form: { remark: '', sumwgt: 0, sumqty: 0, profitwgt: 0, profitqty: 0, losswgt: 0, lossqty: 0 },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            isAdd: false,
            loading: false,
            perData: '',
            nullBtn: false,
            systemSet: '',
            isSave: true,
            type: '4',
            maxHeight: 300,
            maxHeightLeft: 650,
            dtlBarcode: '',
            dtlIndex: '-1', //列表当前位置,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            zkKeyList: [],
            fkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalZkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalFkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '1',

            // 防抖
            debounceTimeout: null, // 用于存储防抖定时器
            perData: {} //权限
        };
    },
    // computed:{
    //     form(newVal,oldVal){
    //         console.log("new",newVal);
    //         console.log("old",oldVal);
    //     }
    // },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getStoneData();
        this.getPermission();
        this.getTable();
        this.getTable1();
        this.getTable2();
        document.addEventListener('keydown.native', this.mykeyup);
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        // this.getData();
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.getData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
                if (this.originalZkKeyList && this.originalZkKeyList.length > 0) {
                    this.zkKeyList = translateColumns(this.originalZkKeyList, newLang || 'zh-CN');
                }
                if (this.originalFkKeyList && this.originalFkKeyList.length > 0) {
                    this.fkKeyList = translateColumns(this.originalFkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        // if (this.$route.query.isadd == 0) {
        //     this.add();
        // } else {
        //     this.getData();
        // }
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.getData();
        }
    },
    methods: {
        showImpotOpen() {
            if (!this.form.counter_no) {
                this.$message.error('请选择柜台');
            } else {
                this.showImpotDialog = true;
                apiGetInventorygetRfidPull({}).then((res) => {
                    this.allArrData = res.data.equipmentcode;
                });
            }
        },
        closingTrue() {
            if (this.insertAllData.length > 0) {
                apiGetInventorygetRfidData({ equipmentcode: this.insertAllData }).then((res) => {
                    if (res.code == 2000) {
                        this.form.dtl = res.data;
                        this.insertAllData = [];
                        this.showImpotDialog = false;
                        this.messageShow(res);
                    } else {
                        this.showImpotDialog = false;
                        this.messageShow(res);
                    }
                });
            }
        },
        handleClose() {
            this.showImpotDialog = false;
        },
        counterChange(e) {
            this.$forceUpdate();
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/barcodestockcheck') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        dialogTrueFalse() {
            if (!this.form.counter_no) {
                this.$message.error('请选择柜台');
            } else {
                this.$load.show();
                apiGetInventoryGetBillnos({ counter_no: this.form.counter_no }).then((res) => {
                    if (res.code == 2000) {
                        this.insertKeywordsArr = res.data;
                        this.$load.close();
                    } else {
                        this.$load.close();
                    }
                });
                this.dialogVisible = true;
            }
        },
        specschange(v) {
            apiGetInventoryMergeBill({ id: this.insertKeywords }).then((res) => {
                this.$load.show();
                if (res.code == 2000) {
                    this.form.dtl = res.data;
                    this.insertKeywords = [];
                    this.$load.close();
                    this.$message.success(res.msg);
                } else {
                    this.$load.close();
                    this.$message.error(res.data.info);
                }
                this.dialogVisible = false;
            });
        },
        messageShow(res) {
            if (res.data.info instanceof Array) {
                let str = [];
                var s = '';
                str = res.data.info;
                for (let i = 0; i < str.length; i++) {
                    s += str[i] + '<br/>';
                }
                this.$message({
                    type: 'error',
                    showClose: true,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: s
                });
            } else {
                this.$message.success(res.data.info);
            }
        },
        // 获取条码信息
        insertTableBcode(e) {
            if (e.keyCode == '13') {
                this.dtlBarcode = e.target.value.trim(); // 去除空格
                clearTimeout(this.debounceTimeout); // 清除上一个定时器

                this.debounceTimeout = setTimeout(async () => {
                    if (!this.form.counter_no) {
                        this.$message.info('请先选择柜台');
                        return;
                    }
                    if (this.dtlBarcode == '') {
                        this.$message.info('请填写条码号');
                        return;
                    }
                    let tableData = this.$refs.xTable1.getTableData().fullData;
                    let idx = tableData.findIndex((item) => {
                        return item.barcode == this.dtlBarcode;
                    });
                    if (idx !== -1) {
                        this.$message.error('条码号重复');
                        this.dtlBarcode = '';
                        return;
                    }
                    let data = {
                        barcode: this.dtlBarcode.trim(),
                        counter_no: this.form.counter_no
                    };
                    apiGetInventoryCheckBroadData(data).then(async (res) => {
                        if (res.code === 2000) {
                            let record = res.data;
                            let { row: newRow } = await this.$refs.xTable1.insertAt(record, -1);
                            await this.$refs.xTable1.setActiveCell(newRow, 'seq');
                            let tableData = this.$refs.xTable1.getTableData().fullData;
                            // 滚动到最后一行
                            this.$nextTick(() => {
                                let lastRow = tableData[tableData.length - 1];
                                if (lastRow) {
                                    this.$refs.xTable1.scrollToRow(lastRow);
                                }
                            });
                            let qty = 0;
                            let wgt = 0;
                            for (let i = 0; i < tableData.length; i++) {
                                qty += Number(tableData[i].qty);
                                wgt += Number(tableData[i].wgt);
                            }
                            this.form.sumqty = qty;
                            this.form.sumwgt = wgt;
                        } else {
                            this.$message.error(res.data.info);
                        }
                        this.dtlBarcode = '';
                    });
                }, 300); // 设置防抖延迟时间
            }
        },
        calculateDifferences() {
            let dtl = this.$refs.xTable1.getTableData().fullData;
            let data = {
                dtl,
                counter_no: this.form.counter_no
            };
            apiCountInventoryCheckDiff(data).then((res) => {
                if (res.code === 2000) {
                    let profit = res.data.profit;
                    let loss = res.data.loss;
                    let surpWgt = 0;
                    let surpQty = 0;
                    let lossWgt = 0;
                    let lossQty = 0;
                    for (let i = 0; i < profit.length; i++) {
                        surpQty += Number(profit[i].qty);
                        surpWgt += Number(profit[i].wgt);
                    }
                    for (let i = 0; i < loss.length; i++) {
                        lossQty += Number(loss[i].qty);
                        lossWgt += Number(loss[i].wgt);
                    }
                    this.form.profitqty = surpQty;
                    this.form.profitwgt = surpWgt;
                    this.form.lossqty = lossQty;
                    this.form.losswgt = lossWgt;
                    this.$set(this.form, 'profit', profit);
                    this.$set(this.form, 'loss', loss);
                    console.log(this.form);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleCloses(done) {
            this.showImpotDialogdr = false;
        },

        // 上传文件之前的钩子
        imptBeforeUpload(f) {
            // this.uploadData.store_no = this.form.store_no;
            // this.uploadData.counter_no = this.form.counter_no;
            // this.uploadData.cust_no = this.form.cust_no;
        },
        // 拖拽成功的钩子 导入
        uploadSuccess(res) {
            if (res.code == 2000) {
                // this.$message.success(res.msg);
                this.messageShow(res);
                this.form.dtl = res.data.data;
                this.showImpotDialogdr = false;
            } else {
                this.messageShow(res);
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_barcodestockcheck`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        // 获取页面信息-----------------------------------------
        getData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiGetInventoryCheckData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.last = res.data.last;
                    this.first = res.data.first;
                    this.maxHeight = 300;
                    this.maxHeightLeft = 650;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                    if (res.data.data.dtl.length > 4) {
                        let length = res.data.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                } else {
                    this.type = '4';
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            this.$load.close();
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiGetInventoryCheckPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 修改成品附加数据
        changeData(row, type) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.pullData[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`pullData[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },

        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '26'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable1() {
            apiGetListCorrespondingData({
                id: '27'
            }).then((res) => {
                // this.zkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalZkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.zkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable2() {
            apiGetListCorrespondingData({
                id: '28'
            }).then((res) => {
                // this.fkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalFkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.fkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '26';
            } else if (type == 2) {
                this.keyList = this.zkKeyList.map((item) => item);
                this.keyStatus = '27';
            } else if (type == 3) {
                this.keyList = this.fkKeyList.map((item) => item);
                this.keyStatus = '28';
            }
            this.drawers = true;
        },

        checkMove() {},
        keycancel() {
            this.drawers = false;
            this.getTable();
            this.getTable1();
            this.getTable2();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.form = { dtl: [] };
            this.getData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/barcodestockcheckHistory');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isedit == true) {
                if (this.form.check == 0) {
                    this.isedit = false;
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 导出
        ExportData() {
            if (!this.form.id) {
                this.$message.error('当前单据状态异常');
                return;
            }
            this.$axios
                .get(this.$baseURL + 'export_barcodestockcheck', {
                    params: {
                        id: this.form.id
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '条码库存盘点.xlsx';
                    link.click();
                });
        },
        // 保存修改------------------------------------------
        saveItSub() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                let table1 = this.$refs.xTable1.getTableData().fullData;
                let profit = this.$refs.xTable2.getTableData().fullData;
                let loss = this.$refs.xTable3.getTableData().fullData;
                data['dtl'] = table1;
                data['profit'] = profit;
                data['loss'] = loss;
                data['check'] = this.form.check == true ? '1' : '0';
                this.$load.show();
                if (this.isAdd == true) {
                    apiAddInventoryCheckData(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            this.form = res.data.data;
                            this.last = res.data.last;
                            this.first = res.data.first;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/barcodestockcheckHistory');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyInventoryCheckData(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            this.form = res.data.data;
                            this.last = res.data.last;
                            this.first = res.data.first;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '' };
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 300;
                this.maxHeightLeft = 650;

                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        //删除产品-----------------------------------------
        delOrder() {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                apiDelInventoryCheckData({
                    id: this.form.id
                }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '删除成功', type: 'success' });
                        if (res.data.data == null) {
                            this.form = {};
                            this.nullBtn = true;
                        } else {
                            this.form = res.data.data;
                            if (this.form.check == 1) {
                                this.isCheck = true;
                            } else {
                                this.isCheck = false;
                            }
                        }
                        this.last = res.data.last;
                        this.first = res.data.first;
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length > 4 && length < 11) {
                this.maxHeightLeft -= 48;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiCheckInventoryCheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.getData(this.form.id);
            });
        },
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/barcodestockcheck' });
                this.getData(this.form.id);
                return;
            }
            this.getData(this.form.id);
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '151'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // refreshs() {
        //     this.$forceUpdate();
        // },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // adddtl() {
        //     this.insertEvent(-1);
        //     let length = this.$refs.xTable1.getTableData().fullData.length;
        //     if (length > 4 && length < 11) {
        //         this.maxHeight += 48;
        //     }
        // },
        goHistory() {
            this.$router.push({ path: '/barcodestockcheckHistory', query: { page: 'barcodestockcheck' } });
        }
    }
};
</script>

<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.el-select {
    width: 100%;
}
.list-item1:hover {
    background-color: #f5f7fa;
}
.orderorder {
    padding-bottom: 100px;
    box-sizing: border-box;
}
.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}
.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.footer {
    // height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
.table_warpper {
    display: flex;
    justify-content: space-between;
    .table_right {
        display: flex;
        flex-direction: column;
        width: 50.4%;
    }
    .table1 {
        padding: 15px;
        box-sizing: border-box;
        background-color: #fff;
        margin-top: 10px;
        padding-top: 0;

        .title {
            display: flex;
            justify-content: start;
            align-items: center;
            .ipt {
                width: 250px;
                margin: 5px 0 5px 20px;
            }
            p {
                margin: 5px 0;
            }
        }
    }
}
// 导入样式
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        /deep/ .el-upload--text {
            width: 100%;
        }
        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
